import { FC } from "react";

import ShowPhoneNumber from "../showPhoneNumber";

import { getDateTimeFormat } from "src/helpers/dateTime";

import { PatientInformationProps } from "./types";
import { isOlderthan18 } from "src/helpers/addCase";
import { formatPhoneNumber } from "src/helpers";
import { PatientPhoneNumber } from "src/pages/addCase/types";



const ShowPatientInformation: FC<PatientInformationProps> = ({ getValues }): JSX.Element => {
  const { patient_attributes } = getValues() as { patient_attributes?: Record<string, any> };
  const drugName = getValues()?.prescription_attributes?.drug_name;
  return (
    <div className="card">
      <div className="card-header">
        <h1 className="m-0">Patient Information</h1>
      </div>

      <div className="card-body">
        <div className="row p-2">
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Title:</label>
              </div>
              <div className="col-6">
                <p>{patient_attributes && patient_attributes.title ? patient_attributes.title : 'N/A'}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Gender:</label>
              </div>
              <div className="col-6">
                <p>{patient_attributes && patient_attributes.gender ? patient_attributes.gender : 'N/A'}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="row p-2">
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">First Name:</label>
              </div>
              <div className="col-6">
                <p>{patient_attributes && patient_attributes.firstname ? patient_attributes.firstname : 'N/A'}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Middle Name:</label>
              </div>
              <div className="col-6">
                <p>{patient_attributes && patient_attributes.middlename ? patient_attributes.middlename : 'N/A'}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="row p-2">
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Last Name:</label>
              </div>
              <div className="col-6">
                <p>{patient_attributes && patient_attributes.lastname ? patient_attributes.lastname : 'N/A'}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">SSN:</label>
              </div>
              <div className="col-6">
                <p>{patient_attributes && patient_attributes.ssn ? patient_attributes.ssn : 'N/A'}</p>
                {/* <p>802-446-2118</p> */}
              </div>
            </div>
          </div>
        </div>
        <div className="row p-2">
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Date of Birth:</label>
              </div>
              <div className="col-6">
                <p>{patient_attributes && patient_attributes.dob ? getDateTimeFormat(patient_attributes.dob)?.split(" ")[0] : 'N/A'}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            {patient_attributes && patient_attributes.dob && !isOlderthan18(patient_attributes.dob)  && drugName === "Furoscix On-Body Infusor" ? (
              <div className="row">
                <div className="col-6">
                  <label className="form-label">Patient Weight:</label>
                </div>
                <div className="col-6">
                  <p>{patient_attributes && patient_attributes.weight && patient_attributes.weight.length > 1 ? patient_attributes.weight : 'N/A'}</p>
                </div>
              </div>
            ) : null}
          </div>
        </div>
        <div className="row p-2">
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">
                  {patient_attributes && patient_attributes.dob && drugName === "Furoscix On-Body Infusor" && !isOlderthan18(patient_attributes.dob) ? "Parent/Guardian Name" : "Caregiver Name"}:
                </label>
              </div>
              <div className="col-6">
                <p>{patient_attributes && patient_attributes.caregiver_name ? patient_attributes.caregiver_name : 'N/A'}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">
                  {patient_attributes && patient_attributes.dob && drugName === "Furoscix On-Body Infusor" && !isOlderthan18(patient_attributes.dob) ? "Parent/Guardian Phone Number" : "Caregiver Phone Number"}:
                </label>
              </div>
              <div className="col-6">
                <p>{patient_attributes && patient_attributes.caregiver_phone_number ? formatPhoneNumber(patient_attributes.caregiver_phone_number)    : 'N/A'}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="row p-2">
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Relation to Patient:</label>
              </div>
              <div className="col-6">
                <p>{patient_attributes && patient_attributes.relationship_to_patient ? patient_attributes.relationship_to_patient : 'N/A'}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Best Time To Contact:</label>
              </div>
              <div className="col-6">
                <p>{patient_attributes && patient_attributes.best_time_to_contact ? patient_attributes.best_time_to_contact : 'N/A'}</p>
              </div>
            </div>
          </div>
        </div>
        {patient_attributes && patient_attributes.phone_numbers ? patient_attributes.phone_numbers.map((phoneNumber: PatientPhoneNumber, index: number) => (
          <ShowPhoneNumber key={index} id={index + 1} phone={phoneNumber}/>
        )) : null}
      </div>
    </div>
  );
};

export default ShowPatientInformation;
